/* eslint-disable no-unused-vars, camelcase */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor () {
      super()

      this.form = this.querySelector('form')
      this.form.querySelector('[name=id]').disabled = false
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      this.submitButton = this.querySelector('[type="submit"]')
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')
      this.additonalProducts = new Set()
      window.addEventListener('product-crosssell-change', this.updateProductCrosssell.bind(this))
      window.addEventListener('product-form:loading', () => { this.loading = true })
      window.addEventListener('product-form:loaded', () => { this.loading = false })
    }

    updateProductCrosssell (e) {
      const selectedProducts = e.detail.selectedProducts
      this.additonalProducts = new Set(selectedProducts)
    }

    onSubmitHandler (evt) {
      evt.preventDefault()
      const formEl = evt.target
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      const isMainProductForm = formEl.querySelector('button[id*="ProductSubmitButton-template"]')

      const formData = new FormData(this.form)
      const variantId = formData.get('id')
      const productId = this.dataset.productId

      const isPdpATC = Boolean(this.closest('.product-buy-buttons') || this.closest('product-sticky-add-to-cart'))
      const hasAddonsModalOnPage = Boolean(document.querySelector('addons-modal'))
      const shouldTriggerAddonsModal = isPdpATC && hasAddonsModalOnPage

      this.handleErrorMessage()
      this.loading = true

      if (window.TentBox?.storeTorqueToolContext) {
        window.TentBox.storeTorqueToolContext(this)
      }

      const items = [{ id: parseInt(variantId), quantity: 1 }]
      if (isMainProductForm) {
        const additionalProductIds = this.getAdditionalProducts()
        additionalProductIds.forEach((addProductId) => {
          items.push({ id: parseInt(addProductId), quantity: 1, properties: { isCrosssell: true } })
        })
      }

      const sectionIds = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : []

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement)
      }

      const requestBody = items.length === 1
        ? { id: items[0].id, quantity: items[0].quantity, sections: sectionIds, sections_url: window.location.pathname }
        : { items, sections: sectionIds, sections_url: window.location.pathname }

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      })
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)
            this.loading = false
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          } else if (!this.cart) {
            window.location = window.routes.cart_url
            this.loading = false
            return
          }

          let finalResponse = response
          if (!response.sections || response.sections === null) {
            try {
              const [drawerRes, bubbleRes] = await Promise.all([
                fetch(`${window.location.pathname}?section_id=cart-drawer`),
                fetch(`${window.location.pathname}?section_id=cart-icon-bubble`),
              ])
              const sections = {}
              if (drawerRes.ok) sections['cart-drawer'] = await drawerRes.text()
              if (bubbleRes.ok) sections['cart-icon-bubble'] = await bubbleRes.text()
              if (Object.keys(sections).length) {
                finalResponse = { ...response, sections }
              }
            } catch (e) {}
          }

          this.error = false
          if (this.cart) {
            this.cart._skipCrossSellAutoExpand = Boolean(this.closest('[data-cross-sells-root]'))
          }
          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(finalResponse)
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: finalResponse }))
              })
            }, { once: true })
            quickAddModal.hide(true)
          } else if (shouldTriggerAddonsModal) {
            window.dispatchEvent(new CustomEvent('cart:added-with-modal', {
              detail: {
                cartResponse: finalResponse,
                variantId,
                productId,
              },
            }))
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: finalResponse }))
          } else {
            this.cart.renderContents(finalResponse)
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: finalResponse }))
          }
        })
        .catch((e) => {})
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          this.loading = false
        })
    }

    getAdditionalProducts () {
      return Array.from(this.additonalProducts)
    }

    handleErrorMessage (errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      if (!this.errorMessageWrapper) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    }

    set loading (val) {
      if (val) {
        this.productInfoEl?.setAttribute('loading', 'true')
        this.setAttribute('loading', 'true')
        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
      } else {
        this.productInfoEl?.setAttribute('loading', 'false')
        this.removeAttribute('loading')
        this.submitButton.removeAttribute('aria-disabled')
        this.submitButton.classList.remove('loading')
      }
    }

    get loading () {
      return this.hasAttribute('loading')
    }

    get productInfoEl () {
      // Try to find the new product-body element first, fallback to old structure
      return document.querySelector('.product-body') || document.querySelector('.product-info__inner')
    }

    get loadingIcon () {
      return this.querySelector('.loading-overlay__spinner')
    }
  })
}
